import React, { useEffect, useState } from 'react';

import classNames from 'classnames';
import { Link, useParams } from 'react-router-dom';
import { handleCopy } from '../../utils';

import ASSETS from '../../assets';
import { bryt } from '../../http';

import dayjs from 'dayjs';
import utc from 'dayjs/plugin/utc';
import relativeTime from 'dayjs/plugin/relativeTime';

dayjs.extend(utc);
dayjs.extend(relativeTime);

const Accounts = () => {
  const address = useParams().id;
  const [tab, setTab] = useState('transactions');

  const [transactions, setTrnasactions] = useState([]);
  const [balance, setBalance] = useState(0);

  const handleTab = tab => {
    setTab(tab);
  };

  const handleGetAccountInfo = async () => {
    try {
      const balance = await bryt.getBalance(address);
      setBalance(balance.result.balance);
      const res = await bryt.getAccountTransactions(address);
      const txHashes = res.result.transaction;
      const result = await Promise.all(
        txHashes.map(tx => bryt.getTransactionByHash(tx))
      );

      const transactions = result.map(r => r.result.transaction);
      setTrnasactions(transactions);
      console.log(transactions);
    } catch (err) {
      console.log(err.message);
    }
  };

  useEffect(() => {
    if (address) {
      handleGetAccountInfo();
    }
    // eslint-disable-next-line
  }, [address]);

  return (
    <div className='flex-grow bg-blocks px-10 py-5'>
      <div className='flex items-center gap-2'>
        <img src={ASSETS.account} className='rounded-full' alt='' />
        <p className='text-[19px] font-bold'>Address </p>
        <p className='text-[15px]'>{address}</p>
        <div className='flex items-center gap-1'>
          <img
            src={ASSETS.copy}
            alt=''
            className='cursor-po'
            onClick={() =>
              handleCopy(address, 'Wallet address copied successfully')
            }
          />
          <img src={ASSETS.barcode} alt='' />
          <img src={ASSETS.msg} className='self-start' alt='' />
        </div>
      </div>
      <div className='border-t border-t-bryt-grey-200 mt-[19px]'></div>
      <p className='text-[14.5px] text-bryt-primary-main mt-[10px] mb-[30px]'>
        Use <span className='font-bold'>RYT SDK</span> for network
        communications
      </p>
      <div className='flex items-center gap-2'>
        <div className='h-[26px] border bg-bryt-grey-100 rounded-3xl border-bryt-grey-200 px-2 flex items-center gap-1'>
          <img src={ASSETS.tag} alt='' />
          <p className='text-[10px] font-semibold'>Titan Builder</p>
          <img src={ASSETS.redirect} alt='' />
        </div>
        <div className='h-[26px] border  rounded-3xl border-bryt-grey-200 px-2 flex items-center gap-1'>
          <img src={ASSETS.rite} alt='' />
          <p className='text-[10px] font-semibold'>Titan Builder</p>
          <img src={ASSETS.infoGrey} alt='' />
        </div>
        <div className='h-[26px] border  rounded-3xl border-bryt-grey-200 px-2 flex items-center gap-1'>
          <p className='text-[10px]'>
            # <span className='font-semibold'>MEV Builder</span>
          </p>
        </div>
      </div>
      <div className='grid grid-cols-12 gap-5 mt-2'>
        <div className='bg-hover col-span-6 p-[17px] rounded-[12px] shadow-account'>
          <p className='text-[14.5px] font-semibold'>Overview</p>
          <p className='text-[12.5px] text-bryt-grey-700 mt-5 uppercase'>
            RYT Balance
          </p>
          <p className='text-[14.5px]'>{balance} RYT</p>
          <p className='text-[12.5px] text-bryt-grey-700 mt-5 uppercase'>
            RYT Value
          </p>
          <p className='text-[14.5px]'>
            $47,557.08 <span className='text-[12.5px]'>(@ $3,758.86/ETH)</span>
          </p>
          <p className='text-[12.5px] text-bryt-grey-700 mt-5 uppercase'>
            Token Holdings
          </p>
          <div className='flex items-center mt-1 gap-2'>
            <div className='flex-grow h-10 rounded-lg border border-bryt-grey-200 flex cursor-not-allowed bg-white items-center px-[13px] justify-between'>
              <p className='text-[14.5px] text-bryt-primary-main'>
                $1.19 <span className='text-[12.5px] '>(68 Tokens)</span>
              </p>
              <img src={ASSETS.arrowDown} alt='' />
            </div>
            <div className='w-10 h-10 rounded-lg border border-bryt-grey-200 grid place-items-center cursor-pointer bg-white'>
              <img src={ASSETS.wallet} alt='' />
            </div>
          </div>
        </div>
        <div className='bg-hover col-span-6 p-[17px] rounded-[12px]  shadow-account'>
          <p className='text-[14.5px] font-semibold'>More Info</p>
          <p className='text-[12.5px] text-bryt-grey-700 mt-5 uppercase'>
            total transactions
          </p>
          <p className='text-[14.5px] text-bryt-primary-main'>
            {transactions?.length} transactions
          </p>
          <p className='text-[12.5px] text-bryt-grey-700 mt-5 uppercase'>
            Last Txn Sent
          </p>
          <p className='text-[14.5px] text-bryt-primary-main'>
            0x559cb2902a…
            <span className='text-bryt-grey-700'>from 22 secs ago</span>
          </p>
          <p className='text-[12.5px] text-bryt-grey-700 mt-5 uppercase'>
            First Txn Sent
          </p>
          <p className='text-[14.5px] text-bryt-primary-main'>
            0x5b1718e894…
            <span className='text-bryt-grey-700'>from 422 days ago</span>
          </p>
        </div>
      </div>
      {/* table section */}
      <div className='flex items-center justify-between mt-[32px]'>
        <div className='flex items-center gap-2'>
          <button
            className={classNames(
              'py-[5px] px-[9px] bg-bryt-grey-200 rounded-lg text-bryt-primary-main',
              tab === 'transactions' && 'text-white bg-bryt-primary-main'
            )}
            onClick={() => handleTab('transactions')}
          >
            <p className='text-inherit text-[12.6px] font-semibold'>
              Transactions
            </p>
          </button>
          {/* <button
            className={classNames(
              'py-[5px] px-[9px] bg-bryt-grey-200 rounded-lg text-bryt-primary-main',
              tab === 'incoming-transactions' &&
                'text-white bg-bryt-primary-main'
            )}
            onClick={() => handleTab('incoming-transactions')}
          >
            <p className='text-inherit text-[12.6px] font-semibold'>
              Incoming Transactions
            </p>
          </button> */}
        </div>
        <div className='flex h-[29px] border border-bryt-grey-200 rounded-md cursor-not-allowed'>
          <div className='flex items-center gap-1 px-2'>
            <img src={ASSETS.advanceFilter} alt='' />
            <p className='text-[12.5px]'>Advanced Filter</p>
          </div>
          <div className='w-[29px] grid place-items-center border-l border-l-bryt-grey-200'>
            <img src={ASSETS.arrowDown} alt='' />
          </div>
        </div>
      </div>
      {/* table */}
      <div className='bg-white  border border-bryt-grey-200 rounded-[12px] shadow-txBox mt-3'>
        <div className='flex items-center justify-between py-5 px-[17px]'>
          <div className='flex items-center gap-2'>
            <img src={ASSETS.arrowDownList} alt='' />
            <p className='text-[14.5px]'>
              Latest {transactions?.length} from a total of{' '}
              <span className='text-bryt-primary-main'>
                {transactions?.length}
              </span>{' '}
              transactions
            </p>
          </div>
          <div className='flex items-center gap-2'>
            <div className='flex items-center gap-[6px] border border-bryt-grey-200 h-[29px] px-[10px] rounded-md cursor-not-allowed'>
              <img src={ASSETS.download} alt='' />
              <p className='text-[12.5px]'> Download Page Data</p>
            </div>
            <div className='flex items-center gap-[6px] border border-bryt-grey-200 h-[29px] px-[10px] rounded-md cursor-not-allowed'>
              <img src={ASSETS.cone} alt='' />
              <img src={ASSETS.arrowDown} alt='' />
            </div>
          </div>
        </div>
        <div className='w-full overflow-auto'>
          <table className='w-full border-collapse'>
            <thead>
              <tr className='bg-bryt-primary-main h-[38px] [&_td]:px-4'>
                <td className=''>
                  <img src={ASSETS.infoLight} alt='' />
                </td>
                <td className='text-[12.5px] font-bold text-white'>
                  Transaction Hash
                </td>
                <td className='text-[12.5px] font-bold text-white'>
                  <div className='flex items-center gap-1'>
                    <span className='text-inherit'>Method </span>
                    <img src={ASSETS.infoGrey} alt='' />
                  </div>
                </td>
                <td className='text-[12.5px] font-bold text-white'>Block</td>
                <td className='text-[12.5px] font-bold text-white'></td>
                <td className='text-[12.5px] font-bold text-white'>From</td>
                <td className='text-[12.5px] font-bold text-white'>To</td>
                <td className='text-[12.5px] font-bold text-white'>Value</td>
                <td className='text-[12.5px] font-bold text-white'></td>
              </tr>
            </thead>
            <tbody>
              {transactions?.map(transaction => (
                <tr
                  key={transaction?.ununix_timestamp}
                  className='h-12 [&_td]:px-4 [&_td]:border-b [&_td]:border-b-bryt-grey-200
                      '
                >
                  <td>
                    <div className='w-[28px] h-[28px] rounded-md border border-bryt-grey-200 grid place-items-center'>
                      <img src={ASSETS.eye} alt='' />
                    </div>
                  </td>
                  <td className='text-[14.5px] text-bryt-primary-main'>
                    {transaction?.TransferObj?.hash ? (
                      <Link
                        to={`/transactions/${transaction?.TransferObj?.hash}`}
                      >
                        <p className='text-[14.5px] text-bryt-primary-main w-[12ch] overflow-hidden text-ellipsis'>
                          {transaction?.TransferObj?.hash}
                        </p>
                      </Link>
                    ) : (
                      'GENISIS_TRANSACTION'
                    )}
                  </td>
                  <td>
                    <div className='h-6 w-[88px] rounded-md border border-bryt-grey-200 grid place-items-center bg-bryt-grey-100'>
                      <p className='text-[11px]'>{transaction?.type}</p>
                    </div>
                  </td>
                  <td className='text-[14.5px] text-bryt-primary-main'>
                    POM Block
                  </td>
                  <td className='text-[14.5px]'>
                    {dayjs.utc(transaction?.transaction_time).fromNow()}
                  </td>
                  <td className=''>
                    <div className='flex items-center gap-2'>
                      <p className='text-[14.5px]'>
                        {transaction?.TransferObj?.from?.slice(0, 7)}.
                      </p>
                      <img src={ASSETS.copy} alt='' />
                      <div className='px-[6.5px] flex items-center h-6 rounded-md bg-bryt-yellow-light border border-yellow-500 text-yellow-500 text-[11px] font-bold'>
                        OUT
                      </div>
                    </div>
                  </td>
                  <td>
                    <div className='flex items-center gap-2'>
                      <p className='text-[14.5px] text-bryt-primary-main'>
                        Fee Recipient:{' '}
                        {transaction?.TransferObj?.to?.slice(0, 5)}.
                      </p>
                      <img src={ASSETS.copy} alt='' />
                    </div>
                  </td>
                  <td className='text-[14.5px]'>
                    {transaction?.TransferObj?.value} RYT
                  </td>
                  <td className='text-[12.5px] text-bryt-grey-700'>
                    0.00029593
                  </td>
                </tr>
              ))}
            </tbody>
          </table>
          <div className='flex justify-center py-4'>
            <div className=' flex items-center gap-[10px] cursor-pointer'>
              <p className='text-xs text-bryt-grey-700 uppercase'>
                View all transactions
              </p>
              <img src={ASSETS.arrowRight} alt='' />
            </div>
          </div>
        </div>
      </div>
      <div className='flex justify-end'>
        <div className='flex items-center gap-1 mt-[10px]'>
          <p className='text-[11.6px]'>
            [ Download:{' '}
            <span className='font-semibold text-bryt-primary-main '>
              CSV Export
            </span>{' '}
          </p>
          <img src={ASSETS.download} alt='' />
          <p className='text-[11.6px]'> ]</p>
        </div>
      </div>
      <div className='flex items-start gap-[14.5px] mt-[14px]'>
        <img src={ASSETS.bulb} alt='' />
        <p className='text-[12.5px] text-bryt-grey-700'>
          Blocks are batches of transactions linked via cryptographic hashes.
          Any tampering of a block would invalidate all following blocks as all
          subsequent hashes would change. Learn more about this page in our{' '}
          <span className='text-bryt-primary-main'>Knowledge Base</span>
        </p>
      </div>
    </div>
  );
};

export default Accounts;
